import giraffe from "@/assets/giraffe.jpg"

export interface IImage {
    getImg(): string
    getImgSmall(): string | null
    getImgMedium(): string | null
    getImgLarge(): string | null
    getImgXL(): string | null
    getImgNumber(): number | null
}

class Image implements IImage {
    private img: string
    private imgSmall: string
    private imgMedium: string
    private imgLarge: string
    private imgXL: string
    private imgNumber: number | null

    constructor(img = '', imgSmall = '', imgMedium = '', imgLarge = '', imgXL = '', imgNumber: number | null = null) {
        this.img = img
        this.imgSmall = imgSmall
        this.imgMedium = imgMedium
        this.imgLarge = imgLarge
        this.imgXL = imgXL
        this.imgNumber = imgNumber
    }

    getImg(): string {
        return this.img
    }
    getImgSmall(): string | null {
        return this.imgSmall
    }
    getImgMedium(): string | null {
        return this.imgMedium
    }
    getImgLarge(): string | null {
        return this.imgLarge
    }
    getImgXL(): string | null {
        return this.imgXL
    }
    getImgNumber(): number | null {
        return this.imgNumber
    }
}

export default Image